export const getCnsInternacao = state => {
    return state.cnsInternacao;
};

export const getErrorCns = state => {
    return state.errorCns;
};

export const getListaProcedimentos = state => {
    return state.listaProcedimentos;
};

export const getListaCid = state => {
    return state.listaCid;
};

export const getConsolidado = state => {
    return state.consolidado;
};